/* eslint-disable react/display-name */
import { forwardRef } from "react";

type PropsOf<
  E extends keyof JSX.IntrinsicElements | React.JSXElementConstructor<any>
> = JSX.LibraryManagedAttributes<E, React.ComponentPropsWithRef<E>>;

export interface PolyphormicProps<
  E extends React.ElementType = React.ElementType
> {
  as?: E | string;
  children?: JSX.Element | JSX.Element[] | string;
}

export type BoxProps<E extends React.ElementType> = PolyphormicProps<E> &
  Omit<PropsOf<E>, keyof PolyphormicProps>;

export type PolymorphicComponentProps<E extends React.ElementType, P> = P &
  BoxProps<E>;

const defaultElement = "span";

export const PolymorphicElement = forwardRef(
  (
    { as = defaultElement, ...restProps }: PolyphormicProps,
    ref: React.Ref<Element>
  ) => {
    const Element = as;
    return <Element ref={ref} {...restProps} />;
  }
) as <E extends React.ElementType = typeof defaultElement>(
  props: BoxProps<E>
) => JSX.Element;
